var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "24px",
    viewBox: "0,0,256,256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#f1c40f",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(10.66667,10.66667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,2c-5.514,0 -10,4.486 -10,10c0,4.92 3.57477,9.01089 8.25977,9.83789c0.044,-0.106 0.07095,-0.21736 0.12695,-0.31836l0.87109,-1.55664c-4.064,-0.375 -7.25781,-3.80189 -7.25781,-7.96289c0,-4.411 3.589,-8 8,-8c4.231,0 7.68884,3.30575 7.96484,7.46875l1.70898,3.01758c0.205,-0.796 0.32617,-1.62633 0.32617,-2.48633c0,-5.514 -4.486,-10 -10,-10zM11,6v5.58594l-3.70703,3.70703l1.41406,1.41406l4.29297,-4.29297v-6.41406zM18,13c-0.3215,0 -0.64313,0.16559 -0.82812,0.49609l-5.03906,9.00195c-0.373,0.666 0.08812,1.50195 0.82813,1.50195h10.07812c0.74,0 1.20113,-0.83595 0.82813,-1.50195l-5.03906,-9.00195c-0.185,-0.3305 -0.50662,-0.49609 -0.82812,-0.49609zM17,16h2v4.00586h-2zM17,21h2l0.00586,2.00195h-2.01172z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.79615ed77ce21b6b1e253b681d2ae50e.svg";
export { ForwardRef as ReactComponent };